// project import
import dashboard from './dashboard';
import finance from './finance';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, finance]
};

export default menuItems;
